import {mapState} from 'vuex'

export default {
    computed: {
        ...mapState({
            relations: state => state.relations.map(el => el.value)
        })
    },
    
    mounted() {
        if(!this.relations.length) {
            this.$store.dispatch('fetchRelations');
        }
    }

}